


























































import Vue, { PropType } from 'vue'
import Logo from '@/components/atoms/Logo/Logo.vue'
import XIcon from '@/components/atoms/Icon/XIcon.vue'
import XDrawerItem, { DrawerItem } from './Item/XDrawerItem.vue'
import XAuthorizations, {
  AllowedPredicate,
} from '@/components/atoms/Auth/XAuthorizations.vue'
import { mapActions, mapState } from 'vuex'
import { Feature, User } from '@/types/generated/graphql'

type DrawerItemPrivate = DrawerItem & { feature?: Feature }

type Data = {
  partnerId: string
  useAffiliate: boolean
}

type Methods = {
  logout: () => Promise<void>
  toggleDrawer: () => void
  handlePressItem: (item: DrawerItem) => Promise<void> | void
  authorizedItems: (allowed: AllowedPredicate) => DrawerItemPrivate[]
}

type Computed = {
  isOpen: boolean
  items: DrawerItemPrivate[]
}

type Props = {
  user?: User
}

// https://material.io/components/navigation-drawer#specs
export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'XDrawer',
  components: { Logo, XIcon, XDrawerItem, XAuthorizations },
  props: {
    user: {
      type: Object as PropType<User>,
      required: false,
    },
  },
  data() {
    return {
      partnerId: this.user?.members?.find(() => true)?.partnerId as string,
      useAffiliate: false,
    }
  },
  computed: {
    ...mapState('drawer', ['isOpen']),
    items() {
      return [
        {
          id: 'services',
          title: this.$tc('services.title'),
          icon: { name: 'mdi-home-outline' },
          routeName: 'Services',
        },
        {
          id: 'partner',
          title: this.$tc('partner.title'),
          icon: { name: 'mdi-handshake-outline' },
          routeName: 'Partner',
        },
        {
          id: 'affiliate',
          title: this.$tc('affiliate.title'),
          icon: { name: 'mdi-cash' },
          routeName: 'AffiliateStores',
          routeParam: { partnerId: this.partnerId },
          feature: Feature.Affiliate,
        },
        {
          id: 'account',
          title: this.$tc('account.title'),
          icon: { name: 'mdi-account-outline' },
          routeName: 'Account',
        },
        {
          id: 'addresses',
          title: this.$tc('partnerShippingAddressList.title'),
          icon: { name: 'mdi-truck-outline' },
          routeName: 'PartnerShippingAddressList',
          routeParam: { partnerId: this.partnerId },
        },
        {
          id: 'creditCard',
          title: this.$tc('creditcard.title'),
          icon: { name: 'mdi-credit-card-outline' },
          routeName: 'CreditCard',
        },
        {
          id: 'orderHistory',
          title: this.$tc('orderHistory.title'),
          icon: { name: 'mdi-cart-outline' },
          routeName: 'Orders',
        },
        // TODO 定期配送認可
        {
          id: 'subscriptions',
          title: this.$tc('subscriptionList.title'),
          icon: { name: 'mdi-sync' },
          routeName: 'Subscriptions',
        },
        {
          id: 'contact',
          title: this.$tc('contact.title'),
          icon: { name: 'mdi-comment-account-outline' },
          routeName: 'Contact',
        },
        {
          id: 'signout',
          title: this.$tc('common.signout'),
          icon: { name: 'mdi-exit-to-app' },
        },
      ]
    },
  },
  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('drawer', ['toggleDrawer']),
    authorizedItems(allowed) {
      return this.items.filter((item) => allowed(item.feature))
    },
    handlePressItem(item) {
      if (item.id === 'signout') {
        this.logout().then(() => {
          this.$router.push({ name: 'Login' })
        })
      }
    },
  },
})
